import { Alert } from '../interfaces';

export const alertsFull: Alert[] = [
  {
    alertType: 'JOB_SEARCH',
    name: 'Job Search',
    description: 'Employee is searching for a new job',
    icon: 'search',
    alertTrigger: 'the employee is searching or interviewing for a new job',
    defaultSeverity: 'medium',
    contextGuidance: `
    Look for evidence of:
    - Job search websites (LinkedIn, Indeed, etc.)
    - Resume preparation
    - Interview scheduling or preparation
    - Discussions about other companies or positions
    - Job applications or cover letters`,
  },
  {
    alertType: 'TIME_MANAGEMENT',
    name: 'Time Management',
    description: 'Employee is spending too much time on non-work activities',
    icon: 'time',
    alertTrigger: 'the employee is spending more than 2 hours on non-work activities',
    defaultSeverity: 'medium',
    contextGuidance: `
    Track time spent on:
    - Social media sites
    - Entertainment websites/apps
    - Personal email or messaging
    - Shopping sites
    - Other clearly non-work activities
    Include actual durations and specific activities.`,
  },
  {
    alertType: 'COMMUNICATION',
    name: 'Communication',
    description: 'Employee is spending too much time on communication tools',
    icon: 'communication',
    alertTrigger: 'employee is spending more than 2 hours a day on communication tools',
    defaultSeverity: 'medium',
    contextGuidance: `
    Track time spent on:
    - Email clients (Gmail, Outlook, etc.)
    - Messaging apps (Slack, Teams, etc.)
    - Video conferencing (Zoom, Meet, etc.)
    - Phone calls or text messaging
    Include actual durations and conversation contexts.`,
  },
  {
    alertType: 'OVER_EMPLOYMENT',
    name: 'Over Employment',
    description: 'Employee is secretly working on multiple full-time positions at the same time',
    icon: 'over-employment',
    alertTrigger: `one of the following is true: if the screen data shows one/more corporate email addresses (different from in the employee context) containing the employee's firstname, lastname or both name or belonging to the employee; the employee works from multiple locations, has multiple Slack accounts and workspaces, multiple job titles, etc.`,
    defaultSeverity: 'medium',
    contextGuidance: `
    For this alert, you MUST extract and list ALL instances of:
    - Email addresses containing the employee's firstname, lastname or both names
    - Messenger (e.g.Slack, Zoom, MatterMost, etc) accounts containing the employee's firstname, lastname or both names and workspaces mentioned
    - Job titles or roles mentioned (especially if different from job title in the employee context)
    - Company or organization names
    - Evidence of working from multiple locations
    - Multiple user profiles or accounts
    DO NOT summarize - provide the actual extracted information with direct evidence.`,
  },
];

// used in the frontend
// we never want to expose context guidance or trigger to the user (frontend)
export const alertsCompact: Omit<Alert, 'contextGuidance' | 'alertTrigger'>[] = alertsFull.map((a) => ({
  alertType: a.alertType,
  name: a.name,
  description: a.description,
  icon: a.icon,
  defaultSeverity: a.defaultSeverity,
}));
